import React, { createContext, useContext, useState } from "react";
import { IOptionContext, ICategory, IModules } from "../exports/interfaces";

const OptionContext = createContext<IOptionContext>({
  categories: [],
  setCategories: () => null,
  statusOptions: [],
  setStatusOptions: () => null,
});

export const useOption = () => useContext(OptionContext);

export const OptionProvider = ({ children }: { children: React.ReactNode }) => {
  const [categories, setCategories] = useState<ICategory[]>([]);
  const [statusOptions, setStatusOptions] = useState<IModules[]>([]);

  return (
    <OptionContext.Provider
      value={{ categories, setCategories, statusOptions, setStatusOptions }}
    >
      {children}
    </OptionContext.Provider>
  );
};
